module.exports = __webpack_public_path__ + "img/06.aa2376b5.jpeg";